import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ImageBannerComponent } from '../../../components/image-banner/image-banner.component';
import { SeatBeltComponent } from '../../../components/seat-belt/seat-belt.component';
import { ServicesCirclesComponent } from '../../../includes/services-circles/services-circles.component';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'pc-division-10',
  standalone: true,
  imports: [
      ImageBannerComponent,
      ServicesCirclesComponent,
      SeatBeltComponent,
    ],
  templateUrl: './division-10.component.html',
  styleUrl: './division-10.component.scss'
})
export class Division10Component implements OnInit {
  // Banner Image
  bannerImgUrl: string | undefined;

  constructor(
    private router: Router,
    private metaService: MetaService
  ) {  }

  ngOnInit(): void {
    this.metaService.setMetadata('division-10');
    // Make sure we're at top of page
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
    
    // Banner Image
    this.bannerImgUrl = 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-6';
  }
}
